import React from 'react';
import { motion } from 'framer-motion';
const MOMENTO = ['Sentís que tu cuerpo cambió y lo que antes te funcionaba ya no alcanza.', 'Querés comer mejor, pero estás cansada de sumar reglas y restricciones.', 'Sabés que necesitás moverte y descansar, pero te cuesta encontrar una rutina que puedas sostener.', 'Leés consejos por todos lados, pero seguís sin saber cómo llevarlos a tu día a día.'];
const phraseVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: 'easeOut'
    }
  }
};
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1.2
    }
  }
};
export function SignalSection() {
  return <section className="bg-gradient-section px-5 pb-20 pt-20 md:px-8 md:pb-24 md:pt-24" style={{
    paddingBottom: '0px',
    paddingTop: "0px"
  }} data-id="element-737" data-mp="34wc7kwz2z769">
      <div className="mx-auto max-w-2xl" data-id="element-738" data-mp="18jztu2pl4ah">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55
      }} className="mb-12 text-left md:mb-16 md:text-center" data-id="element-739" data-mp="19lmkvt37f81">
          <p className="uppercase tracking-[0.22em] text-[#C8A870]" style={{
          fontSize: '12.5px',
          fontFamily: 'sans-serif',
          fontWeight: 600
        }} data-id="element-740" data-mp="1n2y3fl4rv2ds">
            ¿En qué momento estás?
          </p>
          <p className="mt-2 font-display text-[22px] font-semibold leading-tight text-[#F0E8D8]" data-id="element-741" data-mp="1wz17iwj6pb3d">
            Quizás te pase que…
          </p>
          <ul className="mt-3 space-y-2.5" data-id="element-742" data-mp="261aexdj5oocj">
            {MOMENTO.map(item => <li key={item} className="flex gap-2.5 font-body text-[14.5px] leading-snug text-[#F0E8D8]/80 md:justify-center" data-id="element-743" data-mp="260hip6htph8n">
                <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-[#C8A870]" aria-hidden="true" data-id="element-744" data-mp="bn9jz3qq8lhq" />
                <span data-id="element-745" data-mp="6oeq96r81ciu">{item}</span>
              </li>)}
          </ul>
          <p className="mt-5 font-display text-[17px] font-medium italic leading-snug text-[#C8A870]" data-id="element-746" data-mp="6pzob6cqvdlg">
            No necesitás más consejos sueltos. Necesitás una forma de organizarlos.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.4
      }} className="text-left md:text-center" data-id="element-747" data-mp="2golnpfo6z7tc">
          {/* LCP: protagonista estático en el primer render. La animación queda en los elementos posteriores. */}
          <h2 className="font-display font-bold leading-[1.02] tracking-tight text-[#F0E8D8]" style={{
          fontSize: 'clamp(42px, 12vw, 64px)',
          marginBottom: 'clamp(24px, 4vw, 32px)'
        }} data-id="element-748" data-mp="2uod941h1fqhd">
            Tu cuerpo
            <br data-id="element-749" data-mp="34d4wdwb5lmly" />
            no falló.
          </h2>

          <motion.p variants={phraseVariants} className="font-display italic leading-[1.08] text-[#C8A870]" style={{
          fontSize: 'clamp(26px, 6vw, 48px)',
          marginBottom: '0.25em'
        }} data-id="element-750" data-mp="34fzgtnu637fd">
            Cambió la señal.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: 0.35,
          delay: 0.45
        }} className="mx-auto mb-14 flex w-full justify-center md:mb-16" aria-hidden="true" data-id="element-751" data-mp="11sanh864yh6h">
            <svg viewBox="0 0 240 32" className="h-auto w-[72%] max-w-[240px] overflow-visible" fill="none" data-id="element-752" data-mp="nu2utcg4u214">
              <motion.path d="M6 17 C14 7 23 25 32 16 C41 7 50 24 60 15 C70 7 79 22 89 15 C99 9 108 19 119 16 C130 14 140 17 151 16 L210 16" stroke="#C8A870" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" initial={{
              pathLength: 0,
              opacity: 0
            }} whileInView={{
              pathLength: 1,
              opacity: 0.9
            }} viewport={{
              once: true,
              amount: 0.6
            }} transition={{
              pathLength: {
                duration: 1.1,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.5
              },
              opacity: {
                duration: 0.25,
                delay: 0.5
              }
            }} data-id="element-753" data-mp="1ggdtghk6hsva" />

              <motion.circle cx="216" cy="16" r="2.8" fill="#C8A870" initial={{
              opacity: 0,
              scale: 0.5
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.6
            }} transition={{
              delay: 1.45,
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} style={{
              transformOrigin: '216px 16px'
            }} data-id="element-754" data-mp="1a03x4gqmtc4v" />
            </svg>
          </motion.div>

          
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.35
      }} className="mx-auto max-w-xl text-center" style={{
        marginTop: 'clamp(28px, 4vw, 40px)'
      }} data-id="element-755" data-mp="2lm2czjm2i6rj">
          <p className="font-display text-[#F0E8D8]/75" style={{
          fontSize: 'clamp(19px, 4.2vw, 26px)',
          lineHeight: 1.45,
          marginBottom: 'clamp(22px, 4vw, 32px)'
        }} data-id="element-756" data-mp="2vq0wzhgsrbny">
            No es cuestión de exigirte más.
          </p>

          <p className="font-display text-[#F0E8D8]/75" style={{
          fontSize: 'clamp(19px, 4.2vw, 26px)',
          lineHeight: 1.45,
          marginBottom: 'clamp(28px, 5vw, 40px)'
        }} data-id="element-757" data-mp="2gsqe3n1tr3i7">
            Es aprender a acompañar
            <br data-id="element-758" data-mp="2qt0rb7nv0axd" />
            este momento.
          </p>

          <p className="font-display italic text-[#C8A870]/85" style={{
          fontSize: 'clamp(18px, 4vw, 24px)',
          lineHeight: 1.4
        }} data-id="element-759" data-mp="2lrtir6dw77pn">
            Empezá por entender
            <br data-id="element-760" data-mp="12dvumhso35a" />
            qué necesita tu cuerpo hoy.
          </p>
        </motion.div>

        
      </div>
    </section>;
}